// Wrap autoplay video element with one or more source elements that have the `src` attribute replaced with `data-src`
// This component will switch `data-src` to `src` when the video intersects the viewport
class LazyLoadVideo extends HTMLElement {
  static register(tagName) {
    customElements.define(tagName || 'lazy-load-video', LazyLoadVideo)
  }

  connectedCallback() {
    this.lazyVideos = this.querySelectorAll('video:has([data-src])')
    this.observeVideos()
  }

  observeVideos() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) {
          this.loadVideo(target)
        }
      })
    })

    this.lazyVideos.forEach((video) => {
      this.observer.observe(video)
    })
  }

  loadVideo(video) {
    for (const videoSource of video.children) {
      if (videoSource.tagName === 'SOURCE') {
        videoSource.src = videoSource.dataset.src
      }
    }

    video.load()
    // autoplay is not re-evaluated after dynamically assigning sources + load()
    if (video.autoplay) {
      video.play().catch(() => {})
    }
    this.observer.unobserve(video)
  }

  disconnectedCallback() {
    this.observer?.disconnect()
  }
}

if (!customElements.get('lazy-load-video')) {
  customElements.define('lazy-load-video', LazyLoadVideo)
}
